import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { StripePattern } from 'components/StripePattern';

function LiveFlag({ children, isLive }) {
  return (
    <div className={classNames('live-flag', { 'live-flag--active': isLive })} data-test="live-flag">
      <StripePattern className="live-flag__stripes" />
      <span className="live-flag__text" data-test="live-flag__text">
        { isLive && (
          <span className="live-flag__dot" data-test="live-flag__dot" />
        )}
        {children}
      </span>
    </div>
  );
}

LiveFlag.propTypes = {
  isLive: PropTypes.bool,
  children: PropTypes.node,
};

LiveFlag.defaultProps = {
  isLive: false,
  children: null,
};

export default LiveFlag;
